import { ThemeToggle } from "@/components/theme-toggle";
import { SectionHeading } from "@/components/bespoke/section-heading";

/** The account appearance choice: Light, Dark, or System. Saved on this device. */
export function AppearanceSection() {
  return (
    <div className="flex max-w-2xl flex-col gap-3">
      <section aria-label="Appearance" className="rounded-[var(--radius-card)] border p-4">
        <SectionHeading>Theme</SectionHeading>
        <p className="mt-0.5 text-sm text-muted-foreground">
          Light, dark, or follow this device. This choice is saved on this device only.
        </p>
        <div className="mt-3 max-w-xs">
          <ThemeToggle />
        </div>
      </section>
    </div>
  );
}
